import React, { useState } from 'react'
import CustomAlert from '../../shared/CustomAlert'
import { makeAutoObservable, toJS } from 'mobx'
import { observer } from 'mobx-react-lite'
import { MDBCollapse, MDBBtn, MDBIcon, MDBAlert } from 'mdb-react-ui-kit'
import CheckoutStore from './../Checkout.store'
import ACMStore from './../AgentContractManager.store'
import { toast } from 'react-toastify'
import ConfirmDeleteModalComponent from './../../adminShared/ConfirmDeleteModal/ConfirmDeleteModal.component'
import UserProfileService from '../../../shared/services/UserProfile.service'

import './ContractingPacket.scss'
import './CartItemComponent.scss'

const CartItemComponent = ({ item, isOpen, isDisabled }) => {
  return (
    <>
      <div className={'CartItemComponent ' + (isOpen ? 'expand ' : '') + (isDisabled ? 'disable ' : '')}>
        <div className='carrier-name'>
          <div>{ACMStore.CarriersById[item.get('carrier_id')]?.get('c_name')}</div>
          <div className='carrier-descrip'>{ACMStore.CarriersById[item.get('carrier_id')]?.get('c_description')}</div>
        </div>
        <div className='carrier-descrip'>
          <div>{ACMStore.CarriersById[item.get('carrier_id')]?.get('c_description')}</div>
        </div>
        <div className='carrier-comm-level'>
          {(ACMStore.Packet?.comm_codes && ACMStore.Packet.comm_codes[item.get('carrier_id')]) || <small>Agent</small>}
        </div>
        {ACMStore.Packet?.instructions?.carrier[item.get('carrier_id')] ? (
          <div
            className='carrier-instruct'
            dangerouslySetInnerHTML={{
              __html: ACMStore.Packet?.instructions?.carrier[item.get('carrier_id')],
            }}
          />
        ) : (
          <div className='carrier-instruct is-empty'>
            No additional instructions supplied for this carrier contract.
          </div>
        )}
      </div>
    </>
  )
}

const CartItem = observer(CartItemComponent)

class ContractingPacketStore {
  confirmDelete = false
  confirmPacketId = null

  constructor() {
    makeAutoObservable(this)
  }
}

const Store = new ContractingPacketStore()

let intTimerHandle
const ContractingPacket = ({ group, packetId, Packet, onCheckingOutToggle, allCartItems = null }) => {
  const [timer, setTimer] = useState(0),
    // [activeConfirmDeleteModal, setActiveConfirmDeleteModal] = useState(false),
    [isActivating, setIsActivating] = useState(false),
    [isBuilding, setIsBuilding] = useState(false),
    [isCompleting, setIsCompleting] = useState(false),
    isOpen = ACMStore?.Packet?.id === packetId,
    isDisabled = CheckoutStore.groupId !== packetId && CheckoutStore.groupId,
    activate = async () => {
      if (isBuilding) return

      // groupId && CheckoutStore.checkoutCart(groupId)
      setIsActivating(true)
      intTimerHandle = setInterval(() => setTimer(prevTimer => prevTimer + 1), 1000)

      if (!isBuilding) setIsBuilding(true)

      try {
        await ACMStore.viewPacket(packetId)
      } catch (ex) {
        toast.error(`${ex}`, { position: toast.POSITION.TOP_RIGHT })
      }

      setIsBuilding(false)
    },
    deactivate = () => {
      if (isBuilding) return
      ACMStore.packetId = null
      ACMStore.Packet = null
      setIsActivating(false)
      if (intTimerHandle) {
        clearInterval(intTimerHandle)
        intTimerHandle = null
      }
    },
    complete = async link => {
      if (isCompleting) return

      let isCompleted = link === true
      link = link && typeof link === 'string' && `${link}`.trim().length > 0 ? `${link}`.trim() : null

      if (ACMStore.Packet) {
        ACMStore.Packet.has_started = true
      }

      if (isCompleted) {
        setIsCompleting(true)
        try {
          const result = await ACMStore.completePacket()
          if (result?.blockedByAdobe) {
            toast.error('Please finish signing the Adobe contract before completing this packet.', {
              position: toast.POSITION.TOP_RIGHT,
            })
          } else {
            deactivate()
          }
        } catch (ex) {
          toast.error(`Failed to complete packet: ${ex}`, {
            position: toast.POSITION.TOP_RIGHT,
          })
        } finally {
          setIsCompleting(false)
        }
      } else {
        ACMStore.openPacket(link)
      }
    },
    cancel = () => {
      Store.confirmDelete = false
      ACMStore.deletePacket(Store.confirmPacketId).then(async () => {
        if (ACMStore.CartItems.length === 0) {
          onCheckingOutToggle(false)
          ACMStore.removeCheckout()
        }
      })
    },
    renderContractTypeInstructions = () => {
      const cTypes = ACMStore.Packet?.instructions?.contract_type
        ? toJS(ACMStore.Packet.instructions.contract_type)
        : {}
      return (
        <div className='group-ctype-instruct'>
          <ul>
            {Object.keys(cTypes).map((cType, idx) => {
              if (`${cType}`.toLowerCase() === 'pdf')
                return (
                  <li key={`contract-type-instr-${idx}-${cType}`}>
                    <strong style={{ textDecoration: 'underline' }}>Online PDF Contracting</strong>
                    <br />
                    {cTypes[cType] ? <div dangerouslySetInnerHTML={{ __html: cTypes[cType] }}></div> : <></>}
                  </li>
                )
              if (`${cType}`.toLowerCase() === 'link')
                return (
                  <li key={`contract-type-instr-${idx}-${cType}`}>
                    <strong style={{ textDecoration: 'underline' }}>Online Link Contracting</strong>
                    <br />
                    {cTypes[cType] ? <div dangerouslySetInnerHTML={{ __html: cTypes[cType] }}></div> : <></>}
                  </li>
                )
              if (`${cType}`.toLowerCase() === 'acr')
                return (
                  <li key={`contract-type-instr-${idx}-${cType}`}>
                    <strong style={{ textDecoration: 'underline' }}>Online Agent Contract Request</strong>
                    <br />
                    {cTypes[cType] ? <div dangerouslySetInnerHTML={{ __html: cTypes[cType] }}></div> : <></>}
                  </li>
                )
              return ''
            })}
          </ul>
        </div>
      )
    },
    renderFMOInstructions = () => {
      const fmo = ACMStore.Packet?.instructions?.fmo ? toJS(ACMStore.Packet.instructions.fmo) : {},
        fmos = ACMStore.Packet?.fmos ? toJS(ACMStore.Packet.fmos) : {}

      if (fmo && Object.values(fmo).filter(n => !!n).length > 0)
        return (
          <div className='group-fmo-instruct'>
            <ul>
              {Object.keys(fmo).map((fmoId, idx) => (
                <li key={`fmo-instr-${idx}-${fmoId}`}>
                  <strong style={{ textDecoration: 'underline' }}>{fmos[fmoId]} Instructions:</strong>
                  <br />
                  {fmo[fmoId]}
                </li>
              ))}
            </ul>
          </div>
        )
    },
    isPacketIncomplete = () => {
      // Check if packet is not completed
      // First check if packet is loaded and has_completed flag
      if (ACMStore.Packet?.id === packetId && ACMStore.Packet?.has_completed === true) {
        return false
      }

      // Use allCartItems from database if provided, otherwise use filtered CartItems
      const itemsToCheck = allCartItems && allCartItems.length > 0 ? allCartItems : ACMStore.CartItems || []

      // If packet not loaded or not completed, check cart items for this packet
      const packetItems = itemsToCheck.filter(CartItem => CartItem.get('item_group') === packetId)

      if (packetItems.length === 0) return true

      // Packet is incomplete if any item is not COMPLETED or ABANDONED
      // For items with additional_link or is_both_links, they must be COMPLETED (not EXECUTED or ABANDONED)
      return packetItems.some(CartItem => {
        const itemStatus = CartItem.get('item_status')
        const hasAdditionalLink =
          CartItem.get('additional_link') != null &&
          CartItem.get('additional_link') !== '' &&
          String(CartItem.get('additional_link')).trim().length > 0
        const isBothLinks = parseInt(CartItem.get('is_both_links')) === 1

        if (hasAdditionalLink || isBothLinks) {
          // Items with additional links must be COMPLETED, not EXECUTED or ABANDONED
          return itemStatus !== 'COMPLETED'
        } else {
          return !['COMPLETED', 'ABANDONED'].includes(itemStatus)
        }
      })
    },
    hasAdditionalLinksPending = () => {
      // Check if this packet has items with additional_link that are in EXECUTED state (need manual completion)
      // Use allCartItems from database if provided, otherwise use PacketItems
      const itemsToCheck =
        allCartItems && allCartItems.length > 0 ? allCartItems : ACMStore.PacketItems || ACMStore.CartItems || []

      const packetItems = itemsToCheck.filter(CartItem => CartItem.get('item_group') === packetId)

      return packetItems.some(CartItem => {
        const hasAdditionalLink =
          CartItem.get('additional_link') != null &&
          CartItem.get('additional_link') !== '' &&
          String(CartItem.get('additional_link')).trim().length > 0
        const isBothLinks = parseInt(CartItem.get('is_both_links')) === 1
        const itemStatus = CartItem.get('item_status')

        // Item has additional links and is in EXECUTED state (needs manual completion)
        return (hasAdditionalLink || isBothLinks) && itemStatus !== 'COMPLETED'
      })
    },
    renderActionButtons = () => {
      const links = toJS(ACMStore.Packet?.links)
      const needsManualCompletion = hasAdditionalLinksPending()

      if (!links || !links.length) {
        return (
          <>
            {needsManualCompletion && (
              <CustomAlert color='warning' className='additional-links-alert'>
                <MDBIcon icon='exclamation-triangle' className='mr-2' />
                <strong>Action Required:</strong> This packet contains additional contract links that require manual
                completion. Please click the button below once you've completed all contracts.
              </CustomAlert>
            )}
            <div className='row btn-row'>
              <div>
                <MDBBtn type='button' color='default' disabled={true}>
                  Start Contract Packet
                </MDBBtn>
              </div>
              <div>
                <MDBBtn
                  type='button'
                  color={needsManualCompletion ? 'warning' : 'info'}
                  onClick={() => complete(true)}
                  disabled={isCompleting || ACMStore.Packet?.has_completed}
                  className={needsManualCompletion ? 'needs-completion' : ''}
                >
                  {isCompleting ? (
                    <>
                      <i className='fa fa-spin fa-spinner' />
                      &nbsp;Completing...
                    </>
                  ) : (
                    <>
                      Click here once you've <strong>completed</strong> this contract.
                    </>
                  )}
                </MDBBtn>
              </div>
            </div>
          </>
        )
      }

      if (links.length === 1) {
        return (
          <>
            {needsManualCompletion && (
              <CustomAlert color='warning' className='additional-links-alert'>
                <MDBIcon icon='exclamation-triangle' className='mr-2' />
                <strong>Action Required:</strong> This packet contains additional contract links that require manual
                completion. Please click the "Click Here Once Complete" button below once you've finished all contracts.
              </CustomAlert>
            )}
            <div
              className={
                'row btn-row ' +
                (!ACMStore.Packet?.has_completed && ACMStore.Packet?.has_started ? 'can-mark-completed ' : '') +
                (needsManualCompletion ? 'has-pending-additional-links ' : '')
              }
            >
              <div>
                <MDBBtn
                  type='button'
                  color='default'
                  disabled={ACMStore.Packet?.has_completed || isCompleting}
                  onClick={() => complete(links[0])}
                >
                  {ACMStore.Packet?.has_completed
                    ? 'Contract Packet Complete'
                    : ACMStore.Packet?.has_started
                    ? 'Continue Contract Packet'
                    : 'Start Contract Packet'}
                </MDBBtn>
              </div>
              <div>
                <MDBBtn
                  type='button'
                  color={needsManualCompletion ? 'warning' : 'info'}
                  onClick={() => complete(true)}
                  disabled={isCompleting || ACMStore.Packet?.has_completed}
                  className={needsManualCompletion ? 'needs-completion' : ''}
                >
                  {isCompleting ? (
                    <>
                      <i className='fa fa-spin fa-spinner' />
                      &nbsp;Completing...
                    </>
                  ) : (
                    <>
                      Click here once you've <strong>completed</strong> this contract.
                    </>
                  )}
                </MDBBtn>
              </div>
            </div>
          </>
        )
      }

      return (
        <>
          {needsManualCompletion && (
            <CustomAlert color='warning' className='additional-links-alert'>
              <MDBIcon icon='exclamation-triangle' className='mr-2' />
              <strong>Action Required:</strong> This packet contains additional contract links that require manual
              completion. Please click the "Click Here Once Complete" button below once you've finished all contracts.
            </CustomAlert>
          )}
          <div
            className={
              'btn-row row multiple ' +
              (!ACMStore.Packet?.has_completed && ACMStore.Packet?.has_started ? 'can-mark-completed ' : '') +
              (needsManualCompletion ? 'has-pending-additional-links ' : '')
            }
          >
            {links.map((link, idx) => (
              <MDBBtn
                type='button'
                color='info'
                key={`c-actbtn-${idx}`}
                onClick={() => complete(link)}
                disabled={ACMStore.Packet?.has_completed || isCompleting}
              >
                {ACMStore.Packet?.has_completed
                  ? 'Contract Packet Complete'
                  : ACMStore.Packet?.has_started
                  ? 'Continue Contract Packet'
                  : 'Start Contract Packet'}{' '}
                {idx + 1}
              </MDBBtn>
            ))}
            <MDBBtn
              type='button'
              color={needsManualCompletion ? 'warning' : 'info'}
              onClick={() => complete(true)}
              disabled={isCompleting || ACMStore.Packet?.has_completed}
              className={needsManualCompletion ? 'needs-completion' : ''}
            >
              {isCompleting ? (
                <>
                  <i className='fa fa-spin fa-spinner' />
                  &nbsp;Completing...
                </>
              ) : (
                <>
                  Click here once you've <strong>completed</strong> this contract.
                </>
              )}
            </MDBBtn>
          </div>
        </>
      )
    }

  if (isOpen && intTimerHandle) {
    clearInterval(intTimerHandle)
    intTimerHandle = null
  }

  return (
    <div className={'ContractingPacketComponent ' + (isOpen ? 'is-open ' : '') + (isDisabled ? 'is-disabled ' : '')}>
      <div className='cart-group-wrapper'>
        <div className='group-indicator'>
          <div className='ind-bg'>
            contracting packet&nbsp;{packetId}
            {isPacketIncomplete() ? (
              <span className='packet-status-badge incomplete-badge'>Incomplete</span>
            ) : (
              <span className='packet-status-badge completed-badge'>Completed</span>
            )}
          </div>
          <MDBBtn type='button' color='default' onClick={deactivate}>
            <MDBIcon icon='times' />
          </MDBBtn>
        </div>
        <MDBCollapse open={!!isOpen}>
          {renderContractTypeInstructions()}
          {renderFMOInstructions()}
          <div className='group-contracts-heading'>
            <div className='carrier-descrip'>Carrier:</div>
            <div className='carrier-comm-level'>Commission Code:</div>
            <div className='carrier-instruct'>Carrier-Specific Instructions:</div>
          </div>
        </MDBCollapse>
        <ul className='group-contracts'>
          {ACMStore.PacketItems.filter(CartItem => CartItem.get('item_group') === packetId).map((item, idx) => (
            <li key={`cart-item-${item.get('item_group')}-${idx}`}>
              <CartItem item={item} isOpen={isOpen} isDisabled={isDisabled} />
            </li>
          ))}
        </ul>
        <MDBCollapse open={!!isOpen}>
          <div className='group-footer'>
            <div className='contract-actions'>{renderActionButtons()}</div>
          </div>
        </MDBCollapse>
      </div>
      <div className='cart-group-button'>
        <MDBBtn
          type='button'
          color='default'
          className={
            'view-button ' + (parseInt(UserProfileService.get('has_onboarded')) !== 1 ? 'view-button-only' : '')
          }
          disabled={!packetId || isBuilding || !!(ACMStore?.Packet?.id !== packetId && ACMStore?.Packet?.id)}
          onClick={activate}
        >
          {isBuilding && isActivating ? (
            <>
              Preparing Packet&nbsp;
              <i className='fa fa-spin fa-spinner'></i>
              <br />
              <div className='prep-time'>
                <small>
                  Prep Time: Approx{' '}
                  {ACMStore.packetContractTypes[packetId] === 'PDF' || ACMStore.packetContractTypes[packetId] === 'ACR'
                    ? 20
                    : 6}{' '}
                  seconds.
                </small>
                <br />
                Time:&nbsp;{timer}
              </div>
            </>
          ) : (
            <>
              View Contract Packet {`${packetId}`.toUpperCase()}
              <br />
              {}
            </>
          )}
        </MDBBtn>
        {parseInt(UserProfileService.get('has_onboarded')) === 1 && (
          <MDBBtn
            type='button'
            color='default'
            className='cancel-button'
            disabled={!packetId || isBuilding || !!(ACMStore?.Packet?.id !== packetId && ACMStore?.Packet?.id)}
            onClick={() => {
              Store.confirmPacketId = packetId
              Store.confirmDelete = true
            }}
          >
            {
              <small>
                Cancel&nbsp;
                <MDBIcon icon='trash' />
              </small>
            }
          </MDBBtn>
        )}
      </div>
      {Store.confirmDelete && (
        <ConfirmDeleteModalComponent
          shouldEnable={true}
          confirm={`Packet ${Store.confirmPacketId}`}
          onConfirm={() => cancel()}
          onCancel={() => (Store.confirmDelete = false)}
        />
      )}
    </div>
  )
}

export default observer(ContractingPacket)
